// components/SuccessMessage.jsx
import React from "react";
import CommonButton from "./CommonButton";

const SuccessMessage = ({ jobTitle, onClose }) => {
  return (
    <div className="success-message-container">
      <div className="success-icon">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
          <polyline points="22 4 12 14.01 9 11.01"></polyline>
        </svg>
      </div>
      <h2 className="success-title">Application Submitted!</h2>
      <p className="success-message">
        Thank you for applying for the <strong>{jobTitle}</strong> position.
      </p>
      <p className="success-description">
        {"We've received your application and our team will review it shortly. \nYou'll hear from us soon!"}
      </p>
      <CommonButton
        label="Close"
        className="btn-primary"
        onClick={onClose}
      />
    </div>
  );
};

export default SuccessMessage;
